export default class ScrollToTop {
	constructor (clickTargetId) {
		const clickTarget = document.getElementById(clickTargetId);
		if (clickTarget) {
			window.onscroll = function () {
				let windowHeight = window.innerHeight;
				if (window.scrollY >= windowHeight / 2) {
					clickTarget.classList.add("is-visible");
				} else {
					clickTarget.classList.remove("is-visible");
				}
			};
			clickTarget.addEventListener("click", function () {
				window.scrollTo(0, 0);
			});
		}
	}
}
